import { Card, CardContent, CardMedia, Box, Typography, Button, IconButton, Skeleton } from "@mui/material"
import { QueueMusic, PlayArrow } from "@mui/icons-material"

export const PlaylistsSection = ({ playlists, loading }) => {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <Skeleton variant="text" width={160} height={32} />
            <Skeleton variant="rectangular" width={160} height={36} />
          </Box>
          <Box sx={{ display: "flex", gap: 3, overflowX: "auto", pb: 2 }}>
            {[1, 2, 3, 4, 5].map((item) => (
              <Card key={item} sx={{ minWidth: 200, maxWidth: 200 }}>
                <Skeleton variant="rectangular" height={200} />
                <CardContent>
                  <Skeleton variant="text" width="80%" height={24} />
                </CardContent>
              </Card>
            ))}
          </Box>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h5" fontWeight="bold">
            Official Playlists
          </Typography>
          <a href="https://gntunes.com/playlist" target="_blank" className="gn-actionbtn-color" >
            View All Playlists
            <QueueMusic />
          </a>
        </Box>

        {playlists.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              No playlists available
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Official playlists will appear here when available
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              gap: 3,
              overflowX: "auto",
              pb: 2,
              "&::-webkit-scrollbar": { height: 8 },
              "&::-webkit-scrollbar-track": { backgroundColor: "rgba(0,0,0,0.1)", borderRadius: 4 },
              "&::-webkit-scrollbar-thumb": { backgroundColor: "rgba(0,0,0,0.3)", borderRadius: 4 },
            }}
          >
            {playlists.map((playlist, index) => (
              playlist?.privacy_status && <Card
                key={index}
                sx={{
                  minWidth: 200,
                  maxWidth: 200,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 3,
                    "& .play-button": { opacity: 1, transform: "scale(1)" },
                  },
                  cursor:"pointer",
                }}
                onClick={() => window.open(`https://gntunes.com/playlist/${playlist.slug}`, '_blank')}
              >
                {console.debug("officialplaylist", playlist)}

                <Box sx={{ position: "relative" }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={playlist.image || "/placeholder.svg?height=200&width=200"}
                    alt={playlist.title}
                  />
                </Box>
                <CardContent>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {playlist.title}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  )
}
